import isPropValid from "@emotion/is-prop-valid";
import { createElement, type ReactNode } from "react";
import { StyleSheetManager } from "styled-components";
import type { ShouldForwardProp } from "styled-components";

export const shouldForwardProp: ShouldForwardProp<"web"> = (
  prop,
  elementToBeCreated
) => (typeof elementToBeCreated === "string" ? isPropValid(prop) : true);

export function StyledComponentsManager({ children }: { children: ReactNode }) {
  return createElement(
    StyleSheetManager,
    { enableVendorPrefixes: true, shouldForwardProp },
    children
  );
}
